import { IInfiniteData } from '../../../../types';

import { IInventoryInfoData } from '../../../types';

/**
 * Format the response of the inbound inventory list items & Inbound Details.
 */
export function formatInboundInventoryListResponse(
  data: IInfiniteData<IInventoryInfoData> | undefined
): IInventoryInfoData | undefined {
  const firstPage = data?.pages[0];

  if (!firstPage) return undefined;

  const firstPageInboundInventory = firstPage.inbound;
  const missingInventoryCount = firstPage.missingInventoryCount || 0;

  const combinedInboundInventoryList = data.pages.reduce(
    (acc, page) => {
      acc.inventories.push(...page.inboundInventories.inventories);
      acc.total = page.inboundInventories.total;
      acc.pods = page.inboundInventories.pods;
      return acc;
    },
    {
      inventories: [],
      total: 0,
      pods: [],
    } as IInventoryInfoData['inboundInventories']
  );

  return {
    inbound: firstPageInboundInventory,
    inboundInventories: combinedInboundInventoryList,
    missingInventoryCount,
  };
}
